import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Page, formatBRL } from "./_shared";
import { Skeleton } from "@/components/ui/skeleton";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip, CartesianGrid, Legend } from "recharts";

const COLORS = ["#F05A3F", "#60A5FA", "#34D399", "#A78BFA", "#FBBF24", "#FB7185", "#22D3EE", "#F472B6"];

export default function Seasonality() {
  const [data, setData] = useState(null);

  useEffect(() => { api.get("/seasonality").then((r) => setData(r.data.data)); }, []);

  if (!data) return <Skeleton className="h-96" />;

  // Build dataset for stacked bar: [{week: 'S-12', cat1: x, cat2: y...}]
  const weeks = Array.from({ length: 13 }, (_, i) => `S-${12 - i}`);
  const dataset = weeks.map((week, idx) => {
    const obj = { week };
    data.forEach((c) => { obj[c.category] = c.series[idx] || 0; });
    return obj;
  });

  return (
    <Page title="Análise de sazonalidade" subtitle="Padrões de receita por categoria nas últimas 13 semanas.">
      <div className="p-6 rounded-xl border border-border bg-card">
        <ResponsiveContainer width="100%" height={420}>
          <BarChart data={dataset}>
            <CartesianGrid stroke="#1A2B47" strokeDasharray="3 3" />
            <XAxis dataKey="week" stroke="#94A3B8" fontSize={11} />
            <YAxis stroke="#94A3B8" fontSize={11} tickFormatter={(v) => `R$${(v/1000).toFixed(0)}k`} />
            <Tooltip contentStyle={{ backgroundColor: "#0B1320", border: "1px solid #1A2B47", borderRadius: 12 }} formatter={(v) => formatBRL(v)} />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            {data.map((c, i) => (
              <Bar key={c.category} dataKey={c.category} stackId="cat" fill={COLORS[i % COLORS.length]} />
            ))}
          </BarChart>
        </ResponsiveContainer>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
        {data.map((c, i) => {
          const total = c.series.reduce((a, b) => a + b, 0);
          return (
            <div key={c.category} data-testid={`season-${c.category}`} className="p-5 rounded-xl border border-border bg-card">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full" style={{ background: COLORS[i % COLORS.length] }} />
                <div className="text-sm font-medium">{c.category}</div>
              </div>
              <div className="font-display text-2xl font-bold mt-2">{formatBRL(total)}</div>
              <div className="text-xs text-muted-foreground mt-1">acumulado 90 dias</div>
            </div>
          );
        })}
      </div>
    </Page>
  );
}
